<!--suppress ALL -->

<template>
	<tr>
		<td class="text-xs-center">
			{{ area.name }}
		</td>
		<td>
			<edit-btn @click="onEdit"/>
			<remove-btn/>
		</td>

	</tr>
</template>

<script>

	import {types} from "src/store/modules/Area.module";
	import RemoveBtn from "src/scaffoldings/RemoveBtn";
	import EditBtn from "src/scaffoldings/EditBtn";
	import RowMixin from "src/mixins/RowMixin";

	export default {
		name: "area-row",
		props: {
			area: {required: true}
		},
		components: {EditBtn, RemoveBtn},
		mixins: [new RowMixin(types, "area")],
		data() {
			return {};
		},
		computed: {},
		methods: {
			doRemove() {
				this.$store.dispatch(types.REMOVE, this.area).then(() => {
				});
			},
			onEdit() {
				this.$emit("edit", this.area);
			}
		}
	};
</script>

<style>


</style>
